module.exports = __webpack_public_path__ + "a6a240eb97d56cef8ae2f49372691687.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/paint-brush-s.png
// module id = 2080
// module chunks = 0